import FormSection from './FormSection'
import { translations } from '../../data/translations'
import './FormSection.css'

const TechSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.tech || translations.de.tech

  const handleCheckboxChange = (field, value, checked) => {
    const current = formData[field] || []
    const updated = checked
      ? [...current, value]
      : current.filter(v => v !== value)
    updateFormData(field, updated)
  }

  return (
    <FormSection title={t.title} subtitle={t.subtitle}>
      <h3 className="form-section__subtitle">{t.subtitle1}</h3>
      
      <div className="form-group">
        <label className="form-group__label">{t.technologieLabel}</label>
        <div className="checkbox-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '8px' }}>
          {t.technologieOptions.map((option) => (
            <label key={option.value} className="radio-group__option" style={{ padding: '8px 12px' }}>
              <input
                type="checkbox"
                name="technologie[]"
                value={option.value}
                checked={(formData.technologie || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('technologie', option.value, e.target.checked)}
              />
              <span className="radio-group__label" style={{ fontSize: '0.9rem' }}>{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="tech_weitere" className="form-group__label">
          {t.tech_weitere}
        </label>
        <input
          type="text"
          id="tech_weitere"
          name="tech_weitere"
          className="form-group__input"
          placeholder={t.tech_weiterePlaceholder}
          value={formData.tech_weitere || ''}
          onChange={(e) => updateFormData('tech_weitere', e.target.value)}
        />
      </div>

      <h3 className="form-section__subtitle">{t.subtitle2}</h3>

      <div className="form-group">
        <label className="form-group__label">
          {t.cmsBenoetigt} <span className="form-group__required">*</span>
        </label>
        <div className="radio-group">
          {t.cmsOptions.map((option) => (
            <label key={option.value} className="radio-group__option">
              <input
                type="radio"
                name="cms_benoetigt"
                value={option.value}
                checked={formData.cms_benoetigt === option.value}
                onChange={(e) => updateFormData('cms_benoetigt', e.target.value)}
                required
              />
              <span className="radio-group__label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="form-group__label">{t.cmsNutzerLabel}</label>
        <div className="checkbox-group">
          {t.cmsNutzerOptions.map((option) => (
            <label key={option.value} className="radio-group__option">
              <input
                type="checkbox"
                name="cms_nutzer[]"
                value={option.value}
                checked={(formData.cms_nutzer || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('cms_nutzer', option.value, e.target.checked)}
              />
              <span className="radio-group__label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <h3 className="form-section__subtitle">{t.subtitle3}</h3>

      <div className="form-group">
        <label className="form-group__label">{t.integrationenLabel}</label>
        <div className="checkbox-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '8px' }}>
          {t.integrationenOptions.map((option) => (
            <label key={option.value} className="radio-group__option" style={{ padding: '8px 12px' }}>
              <input
                type="checkbox"
                name="integrationen[]"
                value={option.value}
                checked={(formData.integrationen || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('integrationen', option.value, e.target.checked)}
              />
              <span className="radio-group__label" style={{ fontSize: '0.9rem' }}>{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="integrationen_liste" className="form-group__label">
          {t.integrationen_liste}
        </label>
        <textarea
          id="integrationen_liste"
          name="integrationen_liste"
          className="form-group__input form-group__textarea"
          placeholder={t.integrationen_listePlaceholder}
          value={formData.integrationen_liste || ''}
          onChange={(e) => updateFormData('integrationen_liste', e.target.value)}
          style={{ minHeight: '80px' }}
        />
      </div>
    </FormSection>
  )
}

export default TechSection
